export default {
    LOGGING_ENABLED: ['prod', 'production', 'dev', 'stage'].includes(process.env.REACT_APP_ENV),
    DATADOG_SESSIONS_ENABLED: process.env.REACT_APP_DATADOG_SESSIONS_ENABLED === 'true',
    SERVICE: {
        APPLICATION_ID: process.env.REACT_APP_DATADOG_APPLICATION_ID,
        CLIENT_TOKEN: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
    },
};
